module.exports = __webpack_public_path__ + "static/media/Rodape_Logos.1ea066ce.jpg";